import { SLOC_DESKS, slocDesksOf, type Permission } from "@nexseed/shared";
import { redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import type { DeskArea } from "@/features/warehouse/labels";
import {
  deskBlock,
  slocDeskRedirect,
} from "@/features/warehouse/route-helpers";

/** Every Warehouse route's beforeLoad: see `deskBlock`. A form also needs its write code. */
export function guardDesk(stage: string, write?: Permission, area?: DeskArea) {
  if (area === "sloc") {
    // SLOC Updation answers to its desk toggles alone (user, 2026-10-13): no warehouse.view or desk
    // lock. A desk without its toggle goes to one that has it; no toggle at all, home.
    if (!slocDesksOf(useAuth.getState().can).length)
      throw redirect({ to: "/" });
    const desk = slocDeskRedirect(stage);
    if (desk)
      throw redirect({ to: "/warehouse/sloc", search: { stage: desk } });
    if (!SLOC_DESKS.some((d) => d === stage))
      throw redirect({ to: "/warehouse/sloc" });
    return;
  }
  if (write && !useAuth.getState().can(write)) throw redirect({ to: "/" });
  const b = deskBlock(stage, area);
  if (b === "home") throw redirect({ to: "/" });
  if (b === "sloc") throw redirect({ to: "/warehouse/sloc" });
  if (b === "raw") {
    // Seed Status Updation only for a login holding its toggle; else its SLOC desk, else home.
    const { can } = useAuth.getState();
    if (can("warehouse.desk.raw") && can("warehouse.seed_status"))
      throw redirect({
        to: "/warehouse/$stage/seed-status",
        params: { stage: "raw" },
      });
    throw redirect({ to: slocDesksOf(can).length ? "/warehouse/sloc" : "/" });
  }
}
